import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AlertService } from './shared/services/alert/alert.service';
import { AlertComponent } from './shared/components/alert/alert.component';
import { GlobalSpinnerService } from 'src/app/shared/services/global-spinner.service';
import { GlobalSpinnerComponent } from 'src/app/shared/components/global-spinner/global-spinner.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, AlertComponent, GlobalSpinnerComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fade', [
      transition(':enter', [style({ opacity: 0 }), animate('500ms 500ms ease-out', style({ opacity: 1 }))]),
      transition(':leave', [animate('300ms ease-in', style({ opacity: 0 }))]),
    ]),
    trigger('alert', [
      transition(':enter', [
        style({ opacity: 0, height: 0, marginBottom: 0, transform: 'translateY(-100%)' }),
        animate('300ms ease-in', style({ opacity: 1, height: '*', marginBottom: '*', transform: 'translateY(0%)' })),
      ]),
      transition(':leave', [
        animate('300ms ease-out', style({ opacity: 0, height: 0, marginBottom: 0, transform: 'translateY(-100%)' })),
      ]),
    ]),
  ],
})
export class AppComponent {
  title = 'K12 Rounding';
  alerts = this.alertService.alerts;
  isLoading = this.globalSpinnerService.isLoading;

  constructor(
    private alertService: AlertService,
    private globalSpinnerService: GlobalSpinnerService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer
  ) {
    this.addSvgIcon();
  }

  private addSvgIcon(): void {
    this.matIconRegistry.addSvgIcon(
      'k12-small',
      this.domSanitizer.bypassSecurityTrustResourceUrl('assets/icons/k12-small.svg')
    );
  }
}
